// extracted by mini-css-extract-plugin
module.exports = {"bottomNavigatorContainer":"BottomNavigator_bottomNavigatorContainer__RvYHI","subpage":"BottomNavigator_subpage__30lWD"};